import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
} from "react-bootstrap";
import { Variables } from "../../../../Variables1/Variables";
import Util from "../../../../Classes/Util";
import { Row, Col, Modal, Button, Spinner, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CustomToggle({ children, eventKey, onClick }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, (active) =>
    onClick({ state: !active, eventKey: eventKey })
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <Link
      to="#"
      aria-expanded={isCurrentEventKey ? "true" : "false"}
      className="nav-link"
      role="button"
      onClick={(e) => {
        decoratedOnClick(isCurrentEventKey);
      }}
    >
      {children}
    </Link>
  );
}

const VerticalNav = (props) => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  //location
  let location = useLocation();


  return (
    <>
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">Home</span>
            <span className="mini-icon">-</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`${location.pathname === "/" ? "active" : ""} nav-link `}
            aria-current="page"
            to="/"
            onClick={() => { }}
          >
            <i className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M3 10L12 3L21 10V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V10Z"
                  fill="currentColor"
                />
                <path
                  d="M9 22V14H15V22"
                  fill="currentColor"
                />
              </svg>
            </i>
            <span className="item-name">Dashboard</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">Pages</span>
            <span className="mini-icon">-</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>

        {/* Start Contact */}
        <li className="nav-item">
          <Link
            className={`${location.pathname.includes("Contact") ? "active" : ""
              } nav-link `}
            aria-current="page"
            to="/Contact"
          >
            <i className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 6L12 13L2 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </i>

            <span className="item-name">Contact</span>
          </Link>
        </li>

        {/* End About */}

        {/* Start About */}
        <li className="nav-item">
          <Link
            className={`${location.pathname.includes("About") ? "active" : ""
              } nav-link `}
            aria-current="page"
            to="/About"
          >
            <i className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="12"
                  y1="8"
                  x2="12"
                  y2="12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <circle
                  cx="12"
                  cy="16"
                  r="1"
                  fill="currentColor"
                />
              </svg>
            </i>

            <span className="item-name">About</span>
          </Link>
        </li>

        {/* End About */}

        {/* start Menu */}
        {Permissions.ViewMenues === true && (
          <li className="nav-item">
            <Link
              className={`${location.pathname.includes("Menu") ? "active" : ""
                } nav-link `}
              aria-current="page"
              to="/Menu"
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="3" y="6" width="18" height="2" fill="currentColor" />
                  <rect x="3" y="11" width="18" height="2" fill="currentColor" />
                  <rect x="3" y="16" width="18" height="2" fill="currentColor" />
                </svg>
              </i>
              <span className="item-name">Menu</span>
            </Link>
          </li>
        )}

        {/* start Contents */}
        {Permissions.ViewContents === true && (
          <li className="nav-item">
            <Link
              className={`${location.pathname.includes("Content") ? "active" : ""
                } nav-link `}
              aria-current="page"
              to="/Content"
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z"
                    fill="currentColor"
                  />
                  <path
                    d="M14 2V8H20"
                    fill="currentColor"
                  />
                  <path
                    d="M8 12H16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 16H16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </i>
              <span className="item-name">Content</span>
            </Link>
          </li>
        )}
        <li className="nav-item">
          <Link
            className={`${location.pathname.includes("Brand") ? "active" : ""
              } nav-link `}
            aria-current="page"
            to="/Brand"
          >
            <i className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M5 3H15L21 9L15 15H5C3.89543 15 3 14.1046 3 13V5C3 3.89543 3.89543 3 5 3Z"
                  fill="currentColor"
                />
                <path
                  d="M17 7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7Z"
                  fill="currentColor"
                />
              </svg>
            </i>
            <span className="item-name">Brand</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={`${location.pathname.includes("Slides") ? "active" : ""
              } nav-link `}
            aria-current="page"
            to="/Slides"
          >
            <i className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M3 5H21V19H3V5Z"
                  fill="currentColor"
                />
                <path
                  d="M7 9H17V15H7V9Z"
                  fill="currentColor"
                />
              </svg>
            </i>
            <span className="item-name">Slides</span>
          </Link>
        </li>

        {/* start directions */}
        {/* {Permissions.ViewDirections === true && (
          <li className="nav-item">
            <Link
              className={`${
                location.pathname.includes("Directions") ? "active" : ""
              } nav-link `}
              aria-current="page"
              to="/Directions"
            >
              <i className="icon">
                <svg
                  width="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M16.0756 2H19.4616C20.8639 2 22.0001 3.14585 22.0001 4.55996V7.97452C22.0001 9.38864 20.8639 10.5345 19.4616 10.5345H16.0756C14.6734 10.5345 13.5371 9.38864 13.5371 7.97452V4.55996C13.5371 3.14585 14.6734 2 16.0756 2Z"
                    fill="currentColor"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </i>
              <span className="item-name">Directions</span>
            </Link>
          </li>
        )} */}

        {/* end directions */}

        {/* start Widgets */}
        {/* {Permissions.ViewWidgets === true && (
          <li className="nav-item">
            <Link
              className={`${
                location.pathname.includes("Widgets") ? "active" : ""
              } nav-link `}
              aria-current="page"
              to="/Widgets"
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M3 3H11V11H3V3Z"
                    fill="currentColor"
                  />
                  <path
                    opacity="0.4"
                    d="M13 3H21V11H13V3Z"
                    fill="currentColor"
                  />
                  <path
                    opacity="0.4"
                    d="M3 13H11V21H3V13Z"
                    fill="currentColor"
                  />
                  <path
                    d="M13 13H21V21H13V13Z"
                    fill="currentColor"
                  />
                </svg>
              </i>
              <span className="item-name">Widgets</span>
            </Link>
          </li>
        )} */}

        {/* end Widgets */}

        {/* start Authors */}
        {/* {Permissions.ViewAuthors === true && (
          <li className="nav-item">
            <Link
              className={`${
                location.pathname.includes("Author") ? "active" : ""
              } nav-link `}
              aria-current="page"
              to="/Author"
            >
              <i className="icon">
                <svg
                  width="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M16.0756 2H19.4616C20.8639 2 22.0001 3.14585 22.0001 4.55996V7.97452C22.0001 9.38864 20.8639 10.5345 19.4616 10.5345H16.0756C14.6734 10.5345 13.5371 9.38864 13.5371 7.97452V4.55996C13.5371 3.14585 14.6734 2 16.0756 2Z"
                    fill="currentColor"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </i>
              <span className="item-name">Authors</span>
            </Link>
          </li>
        )} */}
        {/* end Authors */}

        {/* start Album */}
        {Permissions.ViewAlbums === true && (
          <li className="nav-item">
            <Link
              className={`${location.pathname.includes("Album") ? "active" : ""
                } nav-link `}
              aria-current="page"
              to="/Album"
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M3 4H21V20H3V4Z"
                    fill="currentColor"
                  />
                  <path
                    d="M5 6H19V18H5V6Z"
                    fill="currentColor"
                  />
                  <path
                    opacity="0.4"
                    d="M7 8H17V16H7V8Z"
                    fill="currentColor"
                  />
                  <circle cx="12" cy="12" r="2" fill="currentColor" />
                </svg>
              </i>
              <span className="item-name">Album</span>
            </Link>
          </li>
        )}
        {/* end Album */}

        {/* start Custom fields type */}
        {Permissions.ViewCustomFieldsType === true && (
          <li className="nav-item">
            <Link
              className={`${location.pathname.includes("CustomFieldsType") ? "active" : ""
                } nav-link `}
              aria-current="page"
              to="/CustomFieldsType"
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M4 4H20V20H4V4Z"
                    fill="currentColor"
                  />
                  <path
                    d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H13V17H7V15Z"
                    fill="currentColor"
                  />
                </svg>
              </i>
              <span className="item-name">Custom Fields Type</span>
            </Link>
          </li>
        )}
        {/* end Custom Fields Type */}

        {/* ================= SEO ================= */}
        <li className="nav-item">
          <CustomToggle
            eventKey="seo"
            onClick={() => { }}
          >
            <i className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M3 3H21V21H3V3Z"
                  fill="currentColor"
                />

                <circle
                  cx="11"
                  cy="11"
                  r="4"
                  fill="currentColor"
                />

                <path
                  d="M14.5 14.5L18 18"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>


            </i>
            <span className="item-name">SEO</span>
          </CustomToggle>

          <Accordion.Collapse eventKey="seo">
            <ul className="sub-nav">
              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/MetaData/1" ? "active" : ""}`} to="/MetaData/1">
                  Home Page
                </Link>
              </li>

              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/MetaData/5" ? "active" : ""}`} to="/MetaData/5">
                  Gallery Page
                </Link>
              </li>

              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/MetaData/6" ? "active" : ""}`} to="/MetaData/6">
                  Contact Page
                </Link>
              </li>

              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/MetaData/7" ? "active" : ""}`} to="/MetaData/7">
                  Career Page
                </Link>
              </li>
              
            </ul>
          </Accordion.Collapse>
        </li>
        {/* ================= END SEO ================= */}

        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">Settings</span>
            <span className="mini-icon">-</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>

        {/* start Language */}

        {/* {Permissions.ViewLanguages === true && (
          <li className="nav-item">
            <Link
              className={`${
                location.pathname.includes("Language") ? "active" : ""
              } nav-link `}
              aria-current="page"
              to="/Language"
            >
              <i className="icon">
                <svg
                  width="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M16.0756 2H19.4616C20.8639 2 22.0001 3.14585 22.0001 4.55996V7.97452C22.0001 9.38864 20.8639 10.5345 19.4616 10.5345H16.0756C14.6734 10.5345 13.5371 9.38864 13.5371 7.97452V4.55996C13.5371 3.14585 14.6734 2 16.0756 2Z"
                    fill="currentColor"
                  ></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </i>
              <span className="item-name">Language</span>
            </Link>
          </li>
        )} */}

        {/* end Language */}

        {/* start Language */}

        {Permissions.ViewRoles === true && (
          <li className="nav-item">
            <Link
              className={`${location.pathname.includes("Role") ? "active" : ""
                } nav-link `}
              aria-current="page"
              to="/Role"
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
                    fill="currentColor"
                  />
                  <path
                    d="M4 20C4 16 8 14 12 14C16 14 20 16 20 20H4Z"
                    fill="currentColor"
                  />
                </svg>
              </i>
              <span className="item-name">Role</span>
            </Link>
          </li>
        )}

        {/* end Roles */}

        {/* start Users */}

        {Permissions.ViewUsers === true && (
          <li className="nav-item">
            <Link
              className={`${location.pathname.includes("Users") ? "active" : ""
                } nav-link `}
              aria-current="page"
              to="/Users"
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M16 11C18.2091 11 20 9.20914 20 7C20 4.79086 18.2091 3 16 3C13.7909 3 12 4.79086 12 7C12 9.20914 13.7909 11 16 11Z"
                    fill="currentColor"
                  />
                  <path
                    opacity="0.4"
                    d="M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11Z"
                    fill="currentColor"
                  />
                  <path
                    d="M2 21C2 16 6 14 12 14C18 14 22 16 22 21H2Z"
                    fill="currentColor"
                  />
                </svg>
              </i>
              <span className="item-name">Users</span>
            </Link>
          </li>
        )}

        {/* end Users List */}
      </Accordion>
    </>
  );
};

export default VerticalNav;
